import React from "react";

function Vin() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 1000 1000">
      <path d="M988 747.5c0 32.6-26.5 59.1-59.1 59.1H69.1c-32.6-2-59.1-28.5-59.1-59.1V250.4c0-30.6 26.5-57 59.1-57h861.8c32.6 0 59.1 26.5 59.1 59.1v495.1h-2zm-55-482.8H65v468.6h870V264.7h-2z"></path>
      <path d="M156.7 386.9c-2-6.1-2-10.2-2-16.3 2-20.4 12.2-32.6 32.6-32.6 12.2 0 22.4 8.1 30.6 22.4l69.3 185.4 69.3-185.4c8.1-14.3 18.3-22.4 30.6-22.4 20.4 2 32.6 14.3 34.6 32.6 0 4.1-2 10.2-4.1 16.3l-97.8 250.6c-6.1 16.3-18.3 24.4-32.6 22.4-16.3 0-26.5-8.2-32.6-22.4l-97.9-250.6zM450.1 372.7c2-22.4 12.2-34.6 32.6-34.6 20.4 2 32.6 12.2 32.6 34.6v254.7c-2 20.4-12.2 30.6-32.6 30.6-20.4 0-32.6-10.2-32.6-30.6V372.7zM570.3 372.7c2-22.4 12.2-34.6 32.6-34.6 12.2 2 20.4 6.1 28.5 16.3L774 543.8h2V374.7c2-22.4 12.2-34.6 32.6-34.6 20.4 2 32.6 12.2 32.6 34.6v254.7c-2 20.4-12.2 30.6-32.6 30.6-12.2 0-20.4-4.1-28.5-12.2L637.5 460.3h-2v169.1c-2 20.4-12.2 30.6-32.6 30.6-20.4 0-32.6-10.2-32.6-30.6V372.7z"></path>
    </svg>
  );
}

export default Vin;
